import React from 'react';
import {concatenate} from "services/string";
import {ChevronRightIcon} from "@heroicons/react/solid";

type Props = {
    icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
    action?: React.ReactNode
    children: React.ReactNode
    hasLink?: boolean
}

function StackedListItem(props: Props) {
    return (
        <li className={`pl-3 pr-4 py-3 flex items-center justify-between text-sm ${props.hasLink && 'hover:bg-gray-50 transition-all duration-200'}`}>
            <div className="w-0 flex-1 flex items-center">
                {props.icon?
                    <props.icon className="flex-shrink-0 h-5 w-5 text-gray-400" />
                : null}

                <div className={concatenate(props.icon? 'ml-2' : null, 'w-full')}>
                    {props.children}
                </div>
            </div>

            {props.action?
                <div className="ml-4 flex-shrink-0">
                    {props.action}
                </div>
            : null}

            {props.hasLink?
              <div className="ml-5 flex-shrink-0">
                  <ChevronRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              : null}
        </li>
    );
}

export default StackedListItem;